import { render, staticRenderFns } from "./SortingHeader.vue?vue&type=template&id=75ace715&scoped=true"
import script from "./SortingHeader.vue?vue&type=script&lang=js"
export * from "./SortingHeader.vue?vue&type=script&lang=js"
import style0 from "./SortingHeader.vue?vue&type=style&index=0&id=75ace715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ace715",
  null
  
)

export default component.exports